import { styled } from "@mui/material";

export const FacModalRoot = styled("div", {
    slot: "root",
    label: "FacModal",
    name: "FacModal"
})`
    &.FacModal-root {
        left: 0;
        top: 0;
        display: flex;
        position: fixed;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.2);
        overflow: hidden;
        z-index: 5;
    }
        
    &.FacModal-root--disabled {
        visibility: hidden;
    }
`;
            
export const FacModalWrapper = styled("div", {
    slot: "wrapper",
    label: "FacModal",
    name: "FacModal",
})`
    &.FacModal-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 600px;
        background-color: white;
    }

    &.FacModal-wrapper--disabled {
        visibility: hidden;
    }
`;

export const FacModalHeader = styled("header", {
    slot: "header",
    label: "FacModal",
    name: "FacModal"
})`
    &.FacModal-header {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 8px 12px;
        width: 100%;
    }

    & .FacModal-header-close {
        margin-left: auto;
    }
`;

export const FacModalBody = styled("div", {
    slot: "body",
    label: "FacModal",
    name: "FacModal"
})`
    &.FacModal-body {
        box-sizing: border-box;
        padding: 0px 12px;
        margin-bottom: 12px;
    }
`;

export default FacModalRoot;
